import { getDateNow } from './utils/helpers'

export const TEMPLATE_FORM_SCAN = {
	document_number: '',
	type: '',
	issuer: '',
	issued_at: null,
	invalid_at: null
}

export const HEADERS_TABLE_SCAN = [
	{
		text: 'number',
		align: 'left',
		sortable: false,
		value: 'document_number'
	},
	{
		text: 'scan_type',
		value: 'type',
		align: 'left',
		sortable: false
	},
	{
		text: 'issued_at',
		value: 'issued_at',
		align: 'left',
		sortable: false
	},
	{
		text: 'invalid_at',
		value: 'invalid_at',
		align: 'left',
		sortable: false
	},
	{
		text: 'actions',
		align: 'center',
		sortable: false
	}
]

export const HEADERS_TABLE_JOBS = [
	{
		text: 'employer_name',
		align: 'left',
		sortable: false,
		value: 'employer_name'
	},
	{
		text: 'job_start',
		align: 'left',
		sortable: false,
		value: 'job_start'
	},
	{
		text: 'job_end',
		align: 'left',
		sortable: false,
		value: 'job_end'
	},
	{
		text: 'active_job',
		align: 'left',
		sortable: false,
		value: 'active_job'
	},
	{
		text: 'actions',
		align: 'center',
		sortable: false
	}
]

export const HEADERS_TABLE_FINANCE = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: false
	},
	{
		text: 'date',
		value: 'created_at',
		sortable: false
	},
	{
		text: 'type',
		align: 'left',
		sortable: false,
		value: 'type'
	},
	{
		text: 'user',
		value: 'user.name',
		sortable: false
	},
	{
		text: 'amount',
		align: 'left',
		sortable: false,
		value: 'amount'
	},
	{
		text: 'comment',
		align: 'left',
		sortable: false,
		value: 'comment'
	},
	{
		text: 'hourly_rate',
		align: 'center',
		sortable: false,
		value: 'hourly_rate'
	},
	{
		text: 'number_hours',
		align: 'center',
		sortable: false,
		value: 'number_hours'
	},
	{
		text: 'subtracted',
		align: 'center',
		sortable: false,
		value: 'subtracted'
	},
	{
		text: 'actions',
		align: 'center',
		sortable: false,
		value: 'actions'
	}
]

export const TEMPLATE_FORM_JOB = {
	employer_id: 0,
	work_address_id: 0,
	cz_isco: '',
	cz_nace: '',
	job_start: '',
	job_end: '',
	job_form: '',
	salary_min: 0,
	salary_max: 0,
	sign_date: '',
	work_permit_number: '',
	work_permit_date: '',
	first_job: false
}

export const TEMPLATE_CONTACT = {
	name: '',
	value: ''
}

export const TEMPLATE_PREPAY = {
	amount: '',
	comment: ''
}

export const TEMPLATE_ADDRESS = {
	id: 0,
	street: '',
	building_number: '',
	smirovaci: '',
	index: '',
	city: '',
	region: '',
	district: '',
	country: ''
}

export const HEADERS_TABLE_ADDRESS = [
	{
		text: 'country',
		align: 'left',
		sortable: false,
		value: 'country',
	},
	{
		text: 'district',
		align: 'left',
		sortable: false,
		value: 'district',
	},
	{
		text: 'region',
		align: 'left',
		sortable: false,
		value: 'region',
	},
	{
		text: 'city',
		align: 'left',
		sortable: false,
		value: 'city',
	},
	{
		text: 'street',
		align: 'left',
		sortable: false,
		value: 'street',
	},
	{
		text: 'building_number',
		align: 'left',
		sortable: false,
		value: 'building_number',
	},
	{
		text: 'index',
		align: 'left',
		sortable: false,
		value: 'index',
	},
	{
		text: 'smirovaci',
		align: 'left',
		sortable: false,
		value: 'smirovaci',
	},
	{
		text: 'actions',
		align: 'center',
		sortable: false,
	}
]

export const HEADERS_TABLE_MAIN_REPORTS = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: false
	},
	{ text: 'date', value: 'created_at', sortable: false },
	{ text: 'firstname', value: 'worker.firstmname', sortable: false },
	{ text: 'lastname', value: 'worker.lastname', sortable: false },
	{ text: 'type', value: 'type', sortable: false },
	{ text: 'user', value: 'user.name', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false },
	{ text: 'comment', value: 'comment', sortable: false },
	{ text: 'subtracted', value: 'subtracted', sortable: false },
	{ text: 'actions', value: 'actions', sortable: false }
]

export const HEADERS_TABLE_WORKER_PAYS = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: false
	},
	{ text: 'date', value: 'created_at', sortable: false },
	{ text: 'firstname', value: 'worker.firstmname', sortable: false },
	{ text: 'lastname', value: 'worker.lastname', sortable: false },
	{ text: 'type', value: 'type', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false },
	{ text: 'comment', value: 'comment', sortable: false },
	{ text: 'subtracted', value: 'subtracted', sortable: false },
]

export const HEADERS_TABLE_USER_FINANCE_PAYS = [
	{
	  text: 'id',
	  align: 'left',
	  value: 'id',
	  sortable: false
	},
	{ text: 'date', value: 'created_at', sortable: false },
	{ text: 'firstname', value: 'worker.firstmname', sortable: false },
	{ text: 'lastname', value: 'worker.lastname', sortable: false },
	{ text: 'type', value: 'type', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false },
	{ text: 'comment', value: 'comment', sortable: false },
	{ text: 'subtracted', value: 'subtracted', sortable: false }
]

export const HEADERS_TABLE_ACCOMODATION = [
	{ text: 'landlord', value: 'landlord_id', sortable: false },
	{
		text: 'apartment_address',
		value: 'apartment_address_id',
		sortable: false,
	},
	{ text: 'room_number', value: 'room_number', sortable: false },
	{ text: 'started_at', value: 'started_at', sortable: false },
	{ text: 'ended_at', value: 'ended_at', sortable: false },
	{ text: 'actions', sortable: false, align: 'center' }
]

export const HEADERS_TABLE_USER_REPORTS = [
	{ text: 'id', value: 'id', sortable: false },
	{ text: 'name', value: 'name', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false }
]
export const HEADERS_TABLE_PERSONAL_FINANCE = [
	{ text: 'id', value: 'id', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false },
	{ text: 'comment', value: 'comment', sortable: false },
	{ text: 'category', value: 'category', sortable: false },
	{ text: 'created_at', value: 'created_at', sortable: false },
	{ text: 'transfer_user_name', value: 'transfer_user_name', sortable: false },
	{ text: 'actions', value: 'actions', sortable: false, align: 'center' }
]

export const HEADERS_TABLE_WORKER_REPORTS = [
	{ text: 'id', value: 'id', sortable: false },
	{ text: 'firstname', value: 'firstname', sortable: false },
	{ text: 'lastname', value: 'lastname', sortable: false },
	{ text: 'amount', value: 'amount', sortable: false }
]

export const HEADERS_TABLE_LANDLORDS = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: true
	},
	{ text: 'landlord_name', value: 'landlord_name', sortable: true },
	{ text: 'person_firstname', value: 'person_firstname', sortable: true },
	{ text: 'person_lastname', value: 'person_lastname', sortable: true },
	{ text: 'actions', align: 'right', value: null, sortable: false }
]

export const HEADERS_TABLE_WORKERS = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: true
	},
	{ text: 'firstname', value: 'firstname', sortable: true },
	{ text: 'lastname', value: 'lastname', sortable: true },
	{ text: 'job_start', value: 'job_start', sortable: false },
	{ text: 'job_end', value: 'job_end', sortable: false },
	{ text: 'agency_name', value: 'agency_name', sortable: false },
	{ text: 'gender', value: 'gender', sortable: true },
	{ text: 'mark', value: 'mark', sortable: true },
	{ text: 'actions', value: 'iron', align: 'right', sortable: false }
]

export const HEADERS_TABLE_EMPLOYER = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: true
	},
	{ text: 'employer_name', value: 'name', sortable: true },
	{ text: 'firstname', value: 'person_firstname', sortable: true },
	{ text: 'lastname', value: 'person_lastname', sortable: true },
	{ text: 'actions', align: 'right', value: null, sortable: false }
]

export const HEADERS_TABLE_DOC_TEMPLATES = [
	{
		text: 'id',
		align: 'left',
		value: 'name',
		sortable: false
	},
	{ text: 'type', value: 'type', sortable: false },
	{ text: 'name', value: 'filename', sortable: false },
	{ text: 'actions', sortable: false }
]

export const HEADERS_TABLE_USER = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: true
	},
	{ text: 'name', value: 'name', sortable: true },
	{ text: 'email', value: 'email', sortable: true },
	{ text: 'actions', align: 'right', value: null, sortable: false }
]

export const HEADERS_TABLE_AGENCY = [
	{
		text: 'id',
		align: 'left',
		value: 'id',
		sortable: true
	},
	{ text: 'name', value: 'name', sortable: true },
	{ text: 'ico', value: 'ico', sortable: true },
	{ text: 'dic', value: 'dic', sortable: true },
	{ text: 'company_number', value: 'company_number', sortable: true },
	{ text: 'actions', value: 'iron', align: 'right' }
]

export const TEMPLATE_WORKER = {
	titul: '',
	firstname: '',
	lastname: '',
	gender: '',
	agency_id: null,
	rodni_chisla: '',
	birth_place: '',
	citizenship: '',
	civil_status: '',
	avatar: null,
	edu_type: '',
	edu_instittution_name: '',
	insurance_number: '',
	contacts: []
}

export const TEMPLATE_EMPLOYER = {
	name: '',
	ico: '',
	dic: '',
	person_titul1: '',
	person_titul2: '',
	person_rodnyChisla: '',
	person_firstname: '',
	person_lastname: '',
	person_gender: ''
}

export const TEMPLATE_LANDLORD = {
	titul_first: '',
	titul_second: '',
	landlord_name: '',
	person_firstname: '',
	person_lastname: '',
	person_gender: '',
	person_document_id: '',
	person_document_issuer: ''
}

export const TEMPLATE_USER = {
	name: '',
	email: '',
	passport: ''
}

export const TEMPLATE_AGENCY = {
	name: '',
	ico: '',
	dic: '',
	company_number: '',
	social_security_number: '',
	spisova_znachka: '',
	mpsv: '',
	contacts: []
}

export const TEMPLATE_ACCOMMODATION = {
	landlord_id: 0,
	apartment_address_id: 0,
	started_at: '',
	ended_at: '',
	room_number: ''
}

export const TEMPLATE_SETTING_ITEM = {
	id: 0,
	value: '',
	key: ''
}

export const TEMPLATE_CHANGE_PASSWORD = {
	password: '',
	repeatPassword: ''
}
